import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SecuritySettingsComponent } from './security-settings.component';
import {MaterialModule} from '../../../material.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ArmFormModule} from '../../../components/arm-form/arm-form.module';
import {ArmFormTitleModule} from '../../../components/arm-form/arm-form-title/arm-form-title.module';
import {InfraModule} from 'ac-infra';



@NgModule({
  declarations: [SecuritySettingsComponent],
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
    FormsModule,
    ArmFormModule,
    ArmFormTitleModule,
    InfraModule
  ]
})
export class SecuritySettingsModule { }
